// Flat views and the lane filter, shared by GanttChart.js and TemplateGantt.js
// (Bill's design, 2026-08-21 - no organise equivalent). Pure filtering over
// buildGanttRows' output: tree order is preserved, the Project Overview row
// survives every combination, and a lane-filtered grouped tree drops any
// status/epic group left with no children.
// Plan: Planning/GANTT-FLAT-VIEWS-2026-08-21.md.

// Which expansion state the row BUILD should use for a view. Flat views must
// ignore status/epic collapse: their group rows are dropped afterwards, but a
// collapsed group would stop its tasks being built at all. 'st' ignores task
// collapse too - every subtask shows. 'mtst' keeps per-task expansion.
export function expansionFor(viewMode, expandedItems) {
    if (!viewMode) return expandedItems;
    if (viewMode === 'mtst') {
        const kept = {};
        for (const [key, value] of Object.entries(expandedItems || {})) {
            if (!key.startsWith('status_') && !key.startsWith('epic_')) kept[key] = value;
        }
        return kept;
    }
    return {};
}

// viewMode: null (grouped tree) | 'mt' | 'mtst' | 'st'
// laneFilter: 'all' | 'tme' | 'team'
export function applyViewMode(rows, viewMode, laneFilter, teamSwimlaneId) {
    let out = rows;

    if (laneFilter && laneFilter !== 'all') {
        // Subtask rows carry mainTaskId, not a lane - resolve through their task.
        const laneOf = new Map();
        rows.forEach(r => {
            if (r.type === 'task') laneOf.set(r.originalId, r.swimlaneId);
        });
        const wantTeam = laneFilter === 'team';
        const inLane = (swimlaneId) => {
            const isTeam = teamSwimlaneId != null && swimlaneId === teamSwimlaneId;
            return wantTeam ? isTeam : !isTeam;
        };
        out = out.filter(r => {
            if (r.type === 'task') return inLane(r.swimlaneId);
            if (r.type === 'subtask') return inLane(laneOf.get(r.mainTaskId));
            return true;
        });
        // A group row with nothing left under it goes too - the tree never
        // shows empty shells.
        out = out.filter((r, i) => {
            if (r.type !== 'status' && r.type !== 'epic') return true;
            for (let j = i + 1; j < out.length; j++) {
                const t = out[j].type;
                if (t === 'status' || t === 'epic' || t === 'project') break;
                if (t === 'task' || t === 'subtask') return true;
            }
            return false;
        });
    }

    if (viewMode === 'mt') {
        out = out
            .filter(r => r.type === 'project' || r.type === 'task')
            .map(r => r.type === 'task' ? { ...r, level: 1, hasChildren: false, isExpanded: false } : r);
    } else if (viewMode === 'mtst') {
        out = out
            .filter(r => r.type === 'project' || r.type === 'task' || r.type === 'subtask')
            .map(r => r.type === 'task' ? { ...r, level: 1 } : r);
    } else if (viewMode === 'st') {
        out = out
            .filter(r => r.type === 'project' || r.type === 'subtask')
            .map(r => r.type === 'subtask' ? { ...r, level: 1 } : r);
    }
    return out;
}
